const CSS_SELECTORS = ['[data-lion-rules-list]', '[data-lion-tier-benefits-compare]', '#loyaltylion', '[data-lion-rewards-list]', '[data-lion-tier-overview]', '[data-lion-history-table]' ];

async function addAccessibilityAttributes(node = null) {
    // Tier Compare Table Cells
    const css_selector = ".lion-tier-compare__header-cell:first-child";
    const elements = Array.from(document.querySelectorAll(css_selector));
    elements.forEach(element => {
        element.innerHTML = "Vorteile";
    });
}

// Funktion zum Einrichten des MutationObserver
function observeMutations() {
    const observerConfig = { childList: true, subtree: true };
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            // console.log("observe");
            mutation.addedNodes.forEach(async node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    await addAccessibilityAttributes(node);
                }
            });
        });
    });
    
    CSS_SELECTORS.forEach(selector => {
        const elements = Array.from(document.querySelectorAll(selector));
        // console.log(selector);
        // console.log(elements);
        elements.forEach(element => {
            observer.observe(element, observerConfig);
        });
    });
}

// Initialisierung des Skripts
window.addEventListener('load', async () => {
    await addAccessibilityAttributes();
    observeMutations();
});
